'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaShareSquare = function FaShareSquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.4 24.6l7.9-7.9q0.4-0.4 0.4-1t-0.4-1l-7.9-7.8q-0.6-0.7-1.5-0.4-0.9 0.4-0.9 1.4v3.5q-2.7 0-4.8 0.5t-3.6 1.1-2.6 1.8-1.7 2.1-1 2.4-0.5 2.5-0.1 2.5q0 4 3.7 9 0.3 0.3 0.6 0.3 0.2 0 0.3-0.1 0.5-0.2 0.4-0.7-1-7.9 1.4-10.6 1-1.1 2.9-1.7t5-0.5v3.6q0 0.9 0.9 1.3 0.3 0.1 0.5 0.1 0.6 0 1-0.4z m11.9-15.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
        )
    );
};

exports.default = FaShareSquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/share-square.js
// module id = 1046
// module chunks = 35783957827783